import type { BuilderPropertyRecord } from '../tool-defaults';
import { LabeledCheckboxRow } from './field-primitives';

export function AcceptScientificNotationCheckbox({ value, onPatch }: { value: boolean; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <LabeledCheckboxRow
            label="Accept scientific notation"
            checked={value}
            onCheckedChange={v => onPatch({ accept_scientific_notation: v })}
        />
    );
}

export function AcceptENotationCheckbox({ value, onPatch }: { value: boolean; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <LabeledCheckboxRow
            label="Accept E notation"
            checked={value}
            onCheckedChange={v => {
                if (v) {
                    onPatch({ accept_E_notation: true });
                } else {
                    onPatch({ accept_E_notation: false, hide_E_notation: false });
                }
            }}
        />
    );
}

export function HideENotationCheckbox({ value, onPatch }: { value: boolean; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <LabeledCheckboxRow
            label="Hide E notation in virtual keyboard"
            checked={value}
            onCheckedChange={v => onPatch({ hide_E_notation: v })}
        />
    );
}
